"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var npcsAndCities = {
  id: "npcsAndCities",
  title: {
    en: "NPCs and cities",
    de: "NPCs und Städte"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "NPCs in Towns and Cities"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Guard"), /*#__PURE__*/_react.default.createElement("p", null, "Entrances to each town, city and portal are protected by NPC guards."), /*#__PURE__*/_react.default.createElement("p", null, "NPC guards are responsible for a town's security, protect players from monsters, and can be aggressive to hostile users."), /*#__PURE__*/_react.default.createElement("p", null, "If you are chased by monsters, run to guards near you and they will provide protection and defeat the monsters.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Weapon Sellers"), /*#__PURE__*/_react.default.createElement("p", null, "Every town has NPC merchants with each selling differnet types of weapons."), /*#__PURE__*/_react.default.createElement("p", null, "Visit NPC merchants for weapons you need.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Armor Sellers"), /*#__PURE__*/_react.default.createElement("p", null, "Every town has NPC merchants selling differnet types of armor.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "SundrY Sellers"), /*#__PURE__*/_react.default.createElement("p", null, "These sellers sell cloaks, bags, and other sundry items.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Magic item Sellers"), /*#__PURE__*/_react.default.createElement("p", null, "Visit these sellers for magical items.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Recipe Sellers"), /*#__PURE__*/_react.default.createElement("p", null, "These sell recipes needed for crafts. Recipes not sold by NPCs need to be acquired from monsters.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Blacksmiths"), /*#__PURE__*/_react.default.createElement("p", null, "Visit blacksmith NPC for crafts. You can also craft on your own if you have enough skills.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Banker"), /*#__PURE__*/_react.default.createElement("p", null, "Banks have a large space where you can store your belongings."), /*#__PURE__*/_react.default.createElement("p", null, "Use the 'exchange' icon to exchange CPs into GPs, and GPs into PPs."), /*#__PURE__*/_react.default.createElement("p", null, "Anything kept in your bank are shared with other characters using the same game account.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Mercenary Managers"), /*#__PURE__*/_react.default.createElement("p", null, "In order to hire mercenaries, you must talk to a mercenary manager (NPC)."), /*#__PURE__*/_react.default.createElement("p", null, "You can hire a Cleric, a Knight, or Archer mercenary for a fee. You can hire mercenaries at your level down to those 15 levels below you. You cannot hire a mercenary with a higher level than you."), /*#__PURE__*/_react.default.createElement("p", null, "It costs money to hire.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Guild Managers"), /*#__PURE__*/_react.default.createElement("p", null, "If you want to keep in close contact with players, visit a guild manager and create a guild of your own."), /*#__PURE__*/_react.default.createElement("p", null, "You must have at least 8 members to form a guild (a full party). The cost is 30PP."), /*#__PURE__*/_react.default.createElement("p", null, "When you create a guild, you can choose your guild emblem and color. In addition, a guild cloak will be given to you representing a unified image among guild members."), /*#__PURE__*/_react.default.createElement("p", null, "Once a guild is formed, members can check for other logged members and use guild chatting for better communications.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Mobile Shop Managers"), /*#__PURE__*/_react.default.createElement("p", null, "There are several mobile shops located far from cities, saving you the time from having to go back and forth from cities to kill monsters."))))
  }
};
var _default = npcsAndCities;
exports.default = _default;